module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "surveyUploadDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeSurveyUploadDialog()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SU0000))]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-controls"
  }, [_c('label', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "id": "fileChooserButton",
      "disabled": _vm.disableAddFileButton
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("note_add")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "fileChooser",
      "accept": _vm.questionData.acceptedTypes,
      "multiple": _vm.questionData.allowMultipleFiles,
      "disabled": _vm.disableAddFileButton
    },
    on: {
      "change": _vm.handleFiles
    }
  }), _vm._v(" "), (
    _vm.questionData.allowMultipleFiles ||
    _vm.selectedFiles.length < 1
  ) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "fileChooserButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0009))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.countFilesToDelete === 0,
      "id": "deleteFilesButton"
    },
    on: {
      "click": function($event) {
        return _vm.onDeleteFiles()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")]), _vm._v(" "), (_vm.countFilesToDelete !== 0) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "deleteFilesButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0010))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiles && _vm.editimg && _vm.canvas.showCanvas),
      expression: "showFiles && editimg && canvas.showCanvas"
    }],
    staticClass: "file-controls"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-save-mini",
    attrs: {
      "type": "button",
      "id": "saveImageButton"
    },
    on: {
      "click": function($event) {
        return _vm.saveImage()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "saveImageButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0011))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "scalingModeButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentMode('crop')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("transform")]), _vm._v(" "), (_vm.currentMode !== 'crop') ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "scalingModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0012))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    class: {
      'btn-mode-selected': _vm.dragMode === 'move' && _vm.currentMode === 'crop',
    },
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "dragModeButton"
    },
    on: {
      "click": function($event) {
        return _vm.onSetDragMode('move')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("open_with")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "dragModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0016))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "zoomInButton"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomIn()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_in")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "zoomInButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0013))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "zoomOutButton"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomOut()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_out")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "zoomOutButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0014))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "zoomToOriginalSizeButton"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomToOriginalSize()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_out_map")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "zoomToOriginalSizeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0015))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "rotateLeftButton"
    },
    on: {
      "click": function($event) {
        return _vm.onRotateLeft()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("rotate_left")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "rotateLeftButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0017))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "rotateRightButton"
    },
    on: {
      "click": function($event) {
        return _vm.onRotateRight()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("rotate_right")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "rotateRightButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0018))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    class: {
      'btn-mode-selected': _vm.dragMode === 'crop' && _vm.currentMode === 'crop',
    },
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "croppingModeButton"
    },
    on: {
      "click": function($event) {
        return _vm.onSetDragMode('crop')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("crop")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "croppingModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0019))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "cropImageButton"
    },
    on: {
      "click": function($event) {
        return _vm.onCropImage()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("crop_free")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "cropImageButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0020))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-mode-select",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'colorize',
      "id": "drawingModeButton"
    },
    on: {
      "click": function($event) {
        _vm.setCurrentMode('colorize'), _vm.setCurrentShape('line')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("brush")]), _vm._v(" "), (_vm.currentMode !== 'colorize') ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "drawingModeButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0021))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "penButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentShape('line')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "penButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0022))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "rectangleButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentShape('rectangle')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("crop_16_9")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "rectangleButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0023))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop',
      "id": "fillRectangleButton"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrentShape('fillrectangle')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("stop")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "fillRectangleButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0024))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop' || _vm.lastActionUndo,
      "id": "undoButton"
    },
    on: {
      "click": function($event) {
        return _vm.undoLastAction()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("undo")]), _vm._v(" "), (!_vm.lastActionUndo) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "undoButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0025))]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "disabled": _vm.currentMode === 'crop' || _vm.lastActionRedo,
      "id": "redoButton"
    },
    on: {
      "click": function($event) {
        return _vm.redoLastAction()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("redo")]), _vm._v(" "), (!_vm.lastActionRedo) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "redoButton",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0026))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-5 control-label",
    attrs: {
      "for": "inputColor"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.canvas.fillStyle),
      expression: "canvas.fillStyle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "color",
      "id": "inputColor"
    },
    domProps: {
      "value": (_vm.canvas.fillStyle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.canvas, "fillStyle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-5 control-label",
    attrs: {
      "for": "linewidth"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.canvas.lineWidth),
      expression: "canvas.lineWidth"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "linewidth",
      "disabled": _vm.currentMode === 'crop'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.canvas, "lineWidth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("10")])])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiles),
      expression: "showFiles"
    }],
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "image-previewmode-grid"
  }, _vm._l((_vm.selectedFiles), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "image",
      class: {
        'image--delete': file.delete,
        'image--active': index === _vm.edit,
      }
    }, [_c('img', {
      staticClass: "image-mini-previewMode",
      attrs: {
        "src": file.imageUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "image__hover"
    }, [_c('div', {
      staticClass: "image__inner"
    }, [_c('a', {
      staticClass: "image__trash",
      on: {
        "click": function($event) {
          return _vm.onToggleDelete(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])]), _vm._v(" "), _c('a', {
      staticClass: "image__edit",
      on: {
        "click": function($event) {
          return _vm.setIndex(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("edit")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edit > -1),
      expression: "edit > -1"
    }],
    staticClass: "image-properties"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0005))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.name ? _vm.editimg.name : "-") + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0006))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.size ?
    _vm.formatBytes(_vm.editimg.size, 1) :
    "-") + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0007))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.lastModified ?
    _vm.formatDate(_vm.editimg.lastModified) :
    "-") + "\n                      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SU0008))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.editimg && _vm.editimg.type ? _vm.editimg.type : "-") + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edit > -1 && _vm.canvas.showCanvas),
      expression: "edit > -1 && canvas.showCanvas"
    }],
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "show-image"
  }, [_c('vue-cropper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentMode === 'crop'),
      expression: "currentMode === 'crop'"
    }],
    ref: "cropper",
    attrs: {
      "guides": true,
      "view-mode": 2,
      "drag-mode": "move",
      "auto-crop-area": 0.5,
      "min-container-width": 250,
      "min-container-height": 180,
      "background": true,
      "rotatable": true,
      "src": _vm.editimg ? _vm.editimg.imageUrl : '',
      "alt": "Source Image",
      "img-style": {
        width: _vm.imageSize.width + 'px',
        height: _vm.imageSize.height + 'px',
      }
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentMode === 'colorize'),
      expression: "currentMode === 'colorize'"
    }],
    attrs: {
      "id": "editCanvas"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeSurveyUploadDialog()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SU0002) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Upload_Create') ||
        !_vm.disableUploadButton
    },
    on: {
      "click": function($event) {
        return _vm.saveFilesToBackend()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SU0001) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401ccfe1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyView/SurveyUploadDialog.vue
// module id = 1672
// module chunks = 1